import * as Highcharts from "highcharts";

Highcharts.setOptions({
  lang: {
    resetZoom: "Сбросить",
  },
});
